
import { ShopHereBtn } from '../Template'
import GallerySlider from '../GallerySlider'
import './landing_page.css'
import './landing_page_desktop.css'


export default function LandingPage() {

    const highlights_photos = [
        {
            url: 'img/highlights_gallery/black_swirls_catear_beanie.jpg',
            description: 'black swirls cat ear beanie'
        },
        {
            url: 'img/highlights_gallery/purple_swirls_catear_beanie.jpg',
            description: 'purple swirls cat ear beanie'
        },
        {
            url: 'img/highlights_gallery/plum scrunchie.jpg',
            description: 'plum scrunchie'
        },
        {
            url: 'img/highlights_gallery/star bag.jpg',
            description: 'star bag'
        },
        {
            url: 'img/highlights_gallery/flower top.jpg',
            description: 'flower pattern crocheted top'
        }
    ]

    return (
        <div className="landingpg-container">
            <section className='landingpg-intro'>
                <div id="landingpg-greeting">
                    <h1 className='landingpg-greeting-txt'>Crochetedly, Tori</h1>
                    <h3 className='landingpg-greeting-txt'>Handmaking cute crocheted apparel and accessories for you!</h3>
                    <p className='landingpg-greeting-txt'>Click the button below to visit my shop and see what's for sale. Otherwise, have a look through this site to see what I can make! DM me on any of my socials if you would like to order something that is not in the shop below.</p>
                    <div className='landingpg-greeting-txt'>
                        <ShopHereBtn />
                    </div>
                </div> 
                <div className='landingpg-portrait-wrapper'>
                    {/** TODO: find a better way to do the circle, e.g. using a transparent background.  
                     * This is probably not best practice since there can be no alt value (shows on top of the image since the src is empty) */}
                    <img className='landingpg-portrait' alt='' /> 
                </div>
            </section> 
            <section className='highlights-gallery'>
                <GallerySlider photos={highlights_photos} />
            </section>
        </div>
    )
}

